import React, { useEffect, useState } from "react";
import { getNotes, addNote, updateNote, deleteNote } from "../api";
// import "../pages/AddNewsAtBottom.css";
export default function AddNewsAtBottom() {
  const [notes, setNotes] = useState([]);
  const [newText, setNewText] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [editingText, setEditingText] = useState("");

  useEffect(() => {
    loadNotes();
  }, []);

  async function loadNotes() {
    const data = await getNotes();
    setNotes(data);
  }

  async function handleAdd() {
    if (!newText.trim()) return;
    await addNote(newText);
    setNewText("");
    loadNotes();
  }

  async function handleUpdate(id) {
    await updateNote(id, editingText);
    setEditingId(null);
    setEditingText("");
    loadNotes();
  }

  async function handleDelete(id) {
    await deleteNote(id);
    loadNotes();
  }

  return (
    <div>
      <div className="add-bar">
        <h2>Outside TV Scrolling News</h2>
        <input
          style={{
            backgroundColor: "#f0f0f0",
            border: "1px solid #ccc",
            borderRadius: "5px",
            padding: "10px",
            fontSize: "16px",
            width: "500px",
          }}
          value={newText}
          onChange={(e) => setNewText(e.target.value)}
          placeholder="Write a News..."
        />
        <button
          onClick={handleAdd}
          style={{
            marginLeft: "10px",
            padding: "10px 20px",
            fontSize: "16px",
            borderRadius: "5px",
            border: "none",
            backgroundColor: "#63A361",
            color: "white",
            cursor: "pointer",
          }}
        >
          Add
        </button>
      </div>

      <ul className="note-list">
        {notes.map((note, idx) => (
          <li
            key={note._id}
            style={{
              marginTop: "4px",
              padding: "10px 20px",
              fontSize: "18px",
              background: "#65b5beff",
              border: "1px solid #eee",
              borderRadius: "4px",
              listStyleType: "none",
              height: "25px",
            }}
          >
            <span className="note-number">{idx + 1}.</span>
            {editingId === note._id ? (
              <>
                <input
                  value={editingText}
                  onChange={(e) => setEditingText(e.target.value)}
                  style={{
                    backgroundColor: "#f0f0f0",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    padding: "10px",
                    fontSize: "16px",
                    width: "500px",
                  }}
                />
                <button
                  onClick={() => handleUpdate(note._id)}
                  style={{
                    marginLeft: "10px",
                    padding: "10px 20px",
                    fontSize: "16px",
                    borderRadius: "5px",
                    border: "none",
                    backgroundColor: "#63A361",
                    color: "white",
                    cursor: "pointer",
                  }}
                >
                  Save
                </button>
                <button
                  onClick={() => setEditingId(null)}
                  style={{
                    marginLeft: "10px",
                    marginRight: "15px",
                    padding: "5px 10px",
                    fontSize: "16px",
                    borderRadius: "5px",
                    border: "none",
                    backgroundColor: "#BF1A1A",
                    color: "white",
                    cursor: "pointer",
                  }}
                >
                  Cancel
                </button>
              </>
            ) : (
              <>
                <span className="note-text">&nbsp;{note.text}</span>&nbsp;&nbsp;
                <button
                  className="update-btn"
                  onClick={() => {
                    setEditingId(note._id);
                    setEditingText(note.text);
                  }}
                  style={{
                    marginLeft: "10px",
                    marginRight: "15px",
                    padding: "5px 10px",
                    fontSize: "16px",
                    borderRadius: "5px",
                    border: "none",
                    backgroundColor: "#FFC50F",
                    color: "black",
                    cursor: "pointer",
                  }}
                >
                  Edit
                </button>
                <button
                  className="logout-btn"
                  onClick={() => handleDelete(note._id)}
                  style={{
                    marginLeft: "10px",
                    marginRight: "15px",
                    padding: "5px 10px",
                    fontSize: "16px",
                    borderRadius: "5px",
                    border: "none",
                    backgroundColor: "#BF1A1A",
                    color: "white",
                    cursor: "pointer",
                  }}
                >
                  Delete
                </button>
              </>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
